import { FC } from "react";

export const ChartFallback: FC = () => (
  <div className="blur-pulse-fallback">
    <div className="blur-pulse-fallback__pulse" />
  </div>
);
